import ReactDOM from 'react-dom/client';
import React from 'react';
import App from "./App";
import 'assets/css/tailwind.css';
import 'assets/css/index.css';
import {Provider} from "react-redux";
import store from './redux/store'


const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    // <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>,
    // </React.StrictMode>
)
